var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    rx: 80,
    fill: "#F5F7F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109 112.625V105.375C109 101.529 107.472 97.8412 104.753 95.122C102.034 92.4027 98.3456 90.875 94.5 90.875H65.5C61.6544 90.875 57.9662 92.4027 55.247 95.122C52.5277 97.8412 51 101.529 51 105.375V112.625M94.5 61.875C94.5 69.8831 88.0081 76.375 80 76.375C71.9919 76.375 65.5 69.8831 65.5 61.875C65.5 53.8669 71.9919 47.375 80 47.375C88.0081 47.375 94.5 53.8669 94.5 61.875Z",
    stroke: "#D9DDDB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAvatar);
export default __webpack_public_path__ + "static/media/noAvatar.2fcb9dda7591abd7a5df0a30ec80b717.svg";
export { ForwardRef as ReactComponent };